import { equalToField } from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { CardType } from '../../../../../../types/cardType';
import { getCommonFields } from '../../../DepositDetails/components/ECheck/ECheck';

import {
  TXTWCL_Account_numbers_do_not_match,
  TXTWCL_Account_types_do_not_match,
  TXTWCL_Bank_routing_number_does_not_m_ELL,
  TXTWCL_Branch_transits_do_not_match,
  TXTWCL_Institution_numbers_do_not_mat_ELL
} from './ECheckConfirm.messages.json';

const fieldName = 'eCheck';

const ECheckConfirm: React.FC = () => {
  const { meta } = useField(`${fieldName}.accountType`);
  const isSiteUS = useSelector(select.cms.isSiteUS);

  const branchErrorMessage = isSiteUS
    ? TXTWCL_Bank_routing_number_does_not_m_ELL
    : TXTWCL_Branch_transits_do_not_match;

  return (
    <>
      {getCommonFields({
        fieldName,
        meta,
        validators: {
          accountType: [equalToField('deposit.accountType', TXTWCL_Account_types_do_not_match)],
          accountNumber: [
            equalToField('deposit.accountNumber', TXTWCL_Account_numbers_do_not_match)
          ],
          institution: [
            equalToField('deposit.institution', TXTWCL_Institution_numbers_do_not_mat_ELL)
          ],
          branch: [equalToField('deposit.branch', branchErrorMessage)]
        },
        cardType: CardType.ECheck
      })}
    </>
  );
};

export default ECheckConfirm;
